/**
 * MAHI — shared letter-choreography for the wordmark assembling itself.
 *
 * Used by both the session-entry animation (MahiIntro) and the route-loading
 * animation (MahiRouteLoader) so the two read as one brand moment rather
 * than two different animations that happen to share the same glyphs. Keep
 * this the single source for the timing/easing — forking either consumer's
 * copy is how they'd quietly drift apart.
 */

/** How far, in viewBox units, each letter travels in from the right. */
export const MAHI_LETTER_TRAVEL = 220;

export const mahiLetterContainer = {
  hidden: {},
  visible: { transition: { delayChildren: 0.12, staggerChildren: 0.075 } },
};

export const mahiLetterVariant = {
  hidden: { x: MAHI_LETTER_TRAVEL, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    // Back-out: the overshoot at the end of the travel is what makes a letter
    // read as *arriving somewhere* rather than sliding to a stop.
    transition: { duration: 0.44, ease: [0.34, 1.56, 0.64, 1] },
  },
};
